import { ClientItem } from 'owa-mail-store';
import UserNote from 'owa-mail-store/lib/store/schema/UserNote';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setUserNoteData', (item: ClientItem, userNoteData: UserNote[]) => {
    item.userNoteData = userNoteData;
});
